import {toast as toastify} from 'react-hot-toast';

export const toast = {
  success: toastify.success,
  error: toastify.error,
  info: toastify.loading,
};
